export default "__VITE_ASSET__DsKVJ4XN__"